import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {connect} from 'react-redux';
import reduxRouteChanged from 'services/reduxRouteChanged.js';
import {purchasesFetch, purchasesResetAction} from './redux';
import Purchases from './Purchases';
import styles from './purchasesController.scss';
import {trackEvent} from "../reducers/analyticsReducer";
import ReactDOM from "react-dom";
import {SmallContinueBanner} from "./smallContinueBanner/smallContinueBanner";
import {SmallApplicationBanner} from "./smallApplicationBanner/smallApplicationBanner";
import {injectIntl, intlShape} from "react-intl";
import * as cardActions from '../card/redux';
import * as thunkActionHelpers from 'utils/redux/thunkActionHelpers';
import {datadogRum} from "@datadog/browser-rum";
import * as cardStatusType from '../constants/cardApplicationStatusTypes';
import {CARD_APPLY_BANNER_LIMIT_KEY, FALSE, TRUE} from "../constants/session-constants";

@connect(
  state => ({
    purchases: state.purchases.purchases,
    document: state.purchases.document,
    active: state.purchases.active,
    actionType: state.purchases.type,
    actionStatus: state.purchases.status,
    card: state.card,
    user: state.auth.user,
  }),
  dispatch => ({
    purchasesFetch: ()=> dispatch(purchasesFetch()),
    purchasesFetchActive: ()=> dispatch(purchasesFetch(true)),
    sunbitCardStatusFetch: ()=> dispatch(cardActions.getSunbitCard(true)),
    trackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
  })
)
@injectIntl
@CSSModules(styles, {allowMultiple: true})
class PurchasesController extends React.Component {

  static propTypes = {
    intl: intlShape,
    purchases: PropTypes.array,
    document: PropTypes.object,
    active: PropTypes.bool.isRequired,
    actionType: PropTypes.string.isRequired,
    actionStatus: PropTypes.string.isRequired,
    card: PropTypes.object,
    user: PropTypes.object,
    purchasesFetch: PropTypes.func.isRequired,
    purchasesFetchActive: PropTypes.func.isRequired,
    sunbitCardStatusFetch: PropTypes.func.isRequired,
    trackEvent: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      link: ''
    };

    const appRoot = document.getElementById('app');
    this.el = document.createElement('div');
    this.el.id = 'smallApplicationBannerContainer';
    this.el.style.zIndex = "5";
    appRoot.appendChild(this.el);
  }

  componentDidMount() {
      this.props.sunbitCardStatusFetch();
  }

  exitModal() {
    this.props.trackEvent("New apply card modal exit", {flow: 'purchases', flowType: 'card'});
    this.setState({
      ...this.state,
      isModalOpen: false,
    });
    this.showSmallModal(false);
  }

  onCloseSmallBanner() {
    document.getElementById('smallApplicationBannerContainer').remove();
  }

  showSmallModal(isContinueModal) {
    const {intl:{formatMessage}} = this.props;
    ReactDOM.render(
      isContinueModal ?
        <SmallContinueBanner formatMessage={formatMessage}
                             continueClicked={this.onContinueClicked.bind(this)}
                             onClose={this.onCloseSmallBanner.bind(this)}/>
        : <SmallApplicationBanner formatMessage={formatMessage}
                                  applyClicked={this.onSmallApplyClicked.bind(this)}
                                  onClose={this.onCloseSmallBanner.bind(this)}/>,
      document.getElementById('smallApplicationBannerContainer')
    );
  }

  onSmallApplyClicked() {
    this.props.trackEvent("New apply small modal clicked", {flow: 'purchases', flowType: 'card'});
    window.open(this.state.link, '_blank');
  }

  onContinueClicked() {
    this.props.trackEvent("Continue apply clicked", {flow: 'purchases', flowType: 'card'});
    window.open(this.state.link, '_blank');
  }

  isFetchStatusSuccess(props) {
    props = props || this.props;
    return thunkActionHelpers.actionSuccess(
      cardActions.FETCH_STATUS,
      props.card.type,
      props.card.status
    );
  }

  isFetchStatusPending(props) {
    props = props || this.props;
    return thunkActionHelpers.actionPending(
      cardActions.FETCH_STATUS,
      props.card.type,
      props.card.status
    );
  }

  isFetchStatusFailed(props) {
    props = props || this.props;
    return thunkActionHelpers.actionFail(
      cardActions.FETCH_STATUS,
      props.card.type,
      props.card.status
    );
  }

  handleSmallBanner(applicationStatus) {
    const isCustomerStartedApplication = applicationStatus === cardStatusType.CREDIT_LINE_DATA_PROVIDED || applicationStatus === cardStatusType.CREDIT_APPROVED;
    this.showSmallModal(isCustomerStartedApplication);
    if (isCustomerStartedApplication) {
      this.props.trackEvent("Continue apply card modal shown", {flow: 'purchases', flowType: 'card'});
      datadogRum.addUserAction('Continue apply card modal shown', {customerId: this.props.user.id});
    }
  }

  handleCardApplyBanner(cardStatus){
    const lastApp = cardStatus.lastApp;
    const applicationStatus = lastApp.clientApplicationStatus;
    // check if entitled client not started a card application and session limitation for showing banner.
    const isShowLargeBannerForCardApply = applicationStatus === cardStatusType.INITIAL  && !this.state.isModalOpen && localStorage.getItem(CARD_APPLY_BANNER_LIMIT_KEY) === TRUE;
    this.setState((prevState) => {
      return {
        ...prevState,
        link: lastApp.link + '&utm_medium=banner&utm_source=mysunbit&utm_class=c',
        isModalOpen : isShowLargeBannerForCardApply
      };
    });
    if (isShowLargeBannerForCardApply) {
      this.props.trackEvent("New apply card modal shown", {flow: 'purchases', flowType: 'card'});
      datadogRum.addUserAction('New apply card modal shown', {customerId: this.props.user.id});
      localStorage.setItem(CARD_APPLY_BANNER_LIMIT_KEY, FALSE);
    }
    else {
      this.handleSmallBanner(applicationStatus);
      }
  }


  componentWillReceiveProps(nextProps) {
    if (!this.isFetchStatusSuccess() && this.isFetchStatusSuccess(nextProps)) {
      const cardStatus = nextProps.card.cardStatus;
      // check if customer not have a card and he is entitled to one
      if (!cardStatus.fullyCreatedAccount && cardStatus.lastApp) {
        this.handleCardApplyBanner(cardStatus)
      }
    }

    // if (!this.isFetchStatusPending() && this.isFetchStatusPending(nextProps)) {}

    if (!this.isFetchStatusFailed() && this.isFetchStatusFailed(nextProps)) {
      datadogRum.addUserAction('Failed fetch card status', {customerId: this.props.user.id, error: nextProps.card.error});
    }
  }

  componentWillUnmount() {
    const element = document.getElementById('smallApplicationBannerContainer');
    if (element) {
      element.remove();
    }
  }

  render() {
    const {purchases, document, active, actionType, actionStatus, purchasesFetch, purchasesFetchActive, card, trackEvent} = this.props;

    return (
      <Purchases
        purchases={purchases}
        document={document}
        active={active}
        purchasesFetch={purchasesFetch}
        purchasesFetchActive={purchasesFetchActive}
        actionType={actionType}
        actionStatus={actionStatus}
        sunbitCardStatus={card.sunbitCardStatus}
        trackEvent={trackEvent}
        isModalOpen={this.state.isModalOpen}
        link={this.state.link}
        onExitModal={this.exitModal.bind(this)}
      />
    );
  }
}

function initStore(dispatch) {
  dispatch(purchasesResetAction());
  return dispatch(purchasesFetch(true));
}

export default reduxRouteChanged(initStore, PurchasesController);



// WEBPACK FOOTER //
// ./src/purchases/PurchasesController.js